module.exports = __webpack_public_path__ + "public/img/mn-open-top.42233b25.png";